"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var translate_1 = require("utils/translate");
var Types = require("types");
var queryString = require("query-string");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var LoginContainer_1 = require("containers/LoginContainer");
var resetPasswordActions = require("@caddigital/sok-reducers/lib/actions/auth/resetPassword");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var classNames = require("classnames");
var connected_react_router_1 = require("connected-react-router");
var LanguageSelectorDropdown_1 = require("components/LanguageSelectorDropdown");
var password_1 = require("utils/password");
var PasswordTabContent_1 = require("components/modals/UserSettingsModal/components/PasswordTabContent");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        resetPassword: state.auth.resetPassword,
        translations: state.translations,
        lang: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    validateData: function (data) {
        return dispatch(resetPasswordActions.validateData(data));
    },
    setPassword: function (password) {
        return dispatch(resetPasswordActions.setResetPasswordAction(password.trim()));
    },
    setConfirmPassword: function (password) {
        return dispatch(resetPasswordActions.setResetPasswordConfirmPasswordAction(password.trim()));
    },
    resetPasswordRequest: function (mode, code, password, confirmPassword, email, language) {
        return dispatch(resetPasswordActions.resetPasswordRequestAction(mode, code || '', password.trim(), confirmPassword.trim(), (email || '').trim().toLowerCase(), language));
    },
    redirect: function (lang) { return dispatch((0, connected_react_router_1.replace)("/".concat(lang))); },
    resendVerification: function (email) {
        return dispatch(resetPasswordActions.resendVerifyEmailRequest(email.trim().toLowerCase()));
    },
    fetchLanguage: function (language) {
        (0, translate_1.setLanguage)(language);
        dispatch((0, translations_1.fetchLanguageRequest)(language));
    },
    redirectToLogin: function (language) { return function () { return dispatch((0, connected_react_router_1.replace)("/".concat(language))); }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var bgNumber = Math.floor(Math.random() * (4 - 1)) + 1;
var changeLanguage = function (language, props) {
    props.history.push("/".concat(language, "/resetpassword"));
    props.fetchLanguage(language);
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var params = queryString.parse(this.props.location.search);
        this.props.validateData(params);
    }
}), recompose_1.pure);
var Loading = function () { return (React.createElement("div", { className: 'loading' },
    React.createElement(sok_ui_1.LoadingSpinner, null))); };
var ExpiredView = function (props) {
    var message = 'userfront/forgotPasswordView/linkExpired';
    var message2 = 'userfront/forgotPasswordView/pleaseRequestNew';
    if (props.resetPassword.resendStatus === 'FAILED') {
        message = 'userfront/ResetPassword/Placeholder/failure';
        message2 = null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(LanguageSelectorDropdown_1.default, { languageCode: props.lang, updateUserLanguage: props.fetchLanguage }),
        React.createElement("div", { className: classNames('message', 'expired', props.resetPassword.resendStatus) }, props.resetPassword.resendStatus !== 'SENDING' ? (React.createElement(React.Fragment, null,
            React.createElement("div", null, (0, translation_1.getLocalization)(message)),
            message2 && React.createElement("div", null, (0, translation_1.getLocalization)(message2)))) : (React.createElement(sok_ui_1.LoadingSpinner, null))),
        React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', disabled: props.resetPassword.resendStatus === 'SENDING', text: (0, translation_1.getLocalization)(props.resetPassword.mode === 'first-time'
                ? 'userfront/forgotPasswordView/sendNewVerificationLinkButton'
                : 'userfront/forgotPasswordView/sendNewForgotPasswordLinkButton'), onClick: function () {
                if (props.resetPassword.mode === 'reset') {
                    props.history.push("/".concat(props.lang, "/forgotpassword").concat(typeof props.resetPassword.email === 'string'
                        ? "?email=".concat(encodeURIComponent(props.resetPassword.email))
                        : ''));
                }
                else {
                    if (props.resetPassword.email !== null) {
                        props.resendVerification(props.resetPassword.email);
                    }
                }
            } }),
        React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', text: (0, translation_1.getLocalization)('userfront/ForgotPassword/Placeholder/BackToLoginPageButton'), onClick: props.redirectToLogin(props.lang) })));
};
var ResetPassword = function (props) {
    var passwordStrength = (0, password_1.getStrength)(props.resetPassword.password);
    if (props.resetPassword.status === 'SENDING') {
        return React.createElement(Loading, null);
    }
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            if (passwordStrength.level < 2)
                return;
            props.resetPasswordRequest(props.resetPassword.mode, props.resetPassword.code, props.resetPassword.password, props.resetPassword.confirmPassword, props.resetPassword.email, props.lang);
        } },
        React.createElement(LanguageSelectorDropdown_1.default, { languageCode: props.lang, updateUserLanguage: props.fetchLanguage }),
        React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('userfront/forgotPasswordView/enterNewPasswordPlaceholder'), autoFocus: true, value: props.resetPassword.password, type: "password", onChange: function (e) {
                return props.setPassword(e.target.value);
            }, icon: React.createElement(Icon_1.Icon, { className: "fa-lock" }) }),
        React.createElement("div", { className: classNames('sok-text-input', 'strength-field', passwordStrength.className) },
            React.createElement(Icon_1.Icon, { className: "fa-link", style: { color: 'black' } }),
            React.createElement("div", { className: "strength-field-text" }, (0, translation_1.getLocalization)(passwordStrength.text))),
        React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('userfront/forgotPasswordView/confirmNewPassword'), type: "password", value: props.resetPassword.confirmPassword, onChange: function (e) {
                return props.setConfirmPassword(e.target.value);
            }, icon: React.createElement(Icon_1.Icon, { className: "fa-lock" }) }),
        React.createElement(sok_ui_1.Button, { size: 'large', color: 'dark-green', disabled: passwordStrength.level < 2, text: (0, translation_1.getLocalization)('userfront/forgotPasswordView/saveText'), type: 'submit' }),
        React.createElement("div", { className: classNames('message', 'error') }, props.resetPassword.status === 'FAILED' && (React.createElement("div", null,
            props.resetPassword.error === 'PASSWORDS_DO_NOT_MATCH' &&
                (0, translation_1.getLocalization)('userfront/forgotPasswordView/passwordsDoNotMatch'),
            props.resetPassword.error === 'API_ERROR' &&
                (0, translation_1.getLocalization)('userfront/ResetPassword/Placeholder/failure')))),
        React.createElement(PasswordTabContent_1.PasswordHint, null)));
};
var LoginRedirectMessage = function () { return (React.createElement("div", { className: 'message' },
    React.createElement("div", { className: 'info-text' },
        React.createElement("div", null, (0, translation_1.getLocalization)('userfront/forgotPasswordView/successText')),
        React.createElement("div", null, (0, translation_1.getLocalization)('userfront/forgotPasswordView/redirectText'))),
    React.createElement("div", { className: 'spinner' },
        React.createElement(sok_ui_1.LoadingSpinner, null)))); };
var views = {
    default: function () { return React.createElement(Loading, null); },
    expired: function (props) { return React.createElement(ExpiredView, __assign({}, props)); },
    form: function (props) { return React.createElement(ResetPassword, __assign({}, props)); },
    login: function () { return React.createElement(LoginRedirectMessage, null); }
};
exports.default = enhance(function (props) {
    var View = views[props.resetPassword.view];
    return (React.createElement(LoginContainer_1.LoginContainer, { bg: bgNumber, translations: props.translations.translations, changeLanguage: function (lang) { return changeLanguage(lang, props); } },
        React.createElement("div", { className: 'reset-password-form' },
            React.createElement(View, __assign({}, props)))));
});
